import { render } from "./dataScreenApproval.vue?vue&type=template&id=1bff5500&scoped=true"
import script from "./dataScreenApproval.vue?vue&type=script&lang=js"
export * from "./dataScreenApproval.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bff5500"]])

export default __exports__